import React, { Component } from 'react'
import Contadores from './Contadores';
import Notificaciones from './Notificaciones';
import GBatery from '../../dashboard/overview/GBatery';
import GSignal from '../../dashboard/overview/GSignal';
import GTempE from '../../dashboard/overview/GTempE';
import GCota from './GCota';
import GTemp from './GTemp';
import GPresion from './GPresion'

export class Page extends Component {

  render() {

    function renderi(num) {

      if (num.length > 0) {
        const styles = (num[2].ultimalectura.presion===null) ? {display: 'none'}:{};
        return (
          <div className="page">

            <header className="header">
              <nav className="navbar">
                <div className="container-fluid">
                  <div className="navbar-holder d-flex align-items-center justify-content-between">
                    <div className="navbar-header"><button id="toggle-btn" className="menu-btn btn-dark"><i className="icon-bars"> </i></button><span href="index.html" className="navbar-brand">
                      <div className="brand-text d-none d-md-inline-block"><span style={{ color: "#ccc" }}>{num[0].nombresitio[0].nombre} </span><strong className="text-primary"> {num[3].estatus}</strong></div></span></div>
                    <Notificaciones />
                  </div>
                </div>
              </nav>
            </header>

            <Contadores lecturas={num[2].ultimalectura} />

            <section className="dashboard-header ">
              <div className="container-fluid">
                <div className="row d-flex align-items-md-stretch">



                  <GCota lecturas={num[1].lecturas} />
                  <GTemp lecturas={num[1].lecturas} />
                  
                  
                  
                </div>
                <div className="row  align-items-md-stretch" style={styles}>



                
                <GPresion lecturas={num[1].lecturas} />



                </div>
                <div className="row d-flex align-items-md-stretch">



                 
                  
                  <GBatery lecturas={num[1].lecturas}  />
                  <GTempE lecturas={num[1].lecturas}  />
                  <GSignal lecturas={num[1].lecturas}  />
                </div>
              </div>
            </section>

          

            <footer className="main-footer">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-6">
                    <p>Instrutrónica -Liderti &copy; 2019</p>
                  </div>
                  <div className="col-sm-6 text-right">
                    <p>Version 1.0.0</p>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        )
      } else {
        return (
          <div>Cargando</div>
        )
      }
    }

    return renderi(this.props.lecturas);
  }
}

export default Page

